import { FetchAPI, FetchOptions, IAuthData, defaultOptionsFetch } from 'ufinet-web-functions'
import { QtCategoryRepository } from '../domain/repository/QtCategoryRepository'
import { QtCategory } from '../domain/QtCategory'

export const HttpQtCategoryRepository: (authData: IAuthData) => QtCategoryRepository = (
	authData
) => {
	const url = `${process.env.REACT_APP_URL_BACK_GTI}qTCategory`

	const fetchOptions: FetchOptions = {
		...defaultOptionsFetch,
		authenticationData: authData,
		sendApiKey: true,
		apiKey: process.env.VITE_API_KEY,
	}

	return {
		findAll: async (options?: FetchOptions): Promise<QtCategory[]> =>
			await FetchAPI.get(`${url}/GetQtCategory`, {
				...fetchOptions,
				...options,
			}),
	}
}
